import React from 'react';

interface FacilitiesSearchFormProps {
  selectedCountry: string;
  setSelectedCountry: (country: string) => void;
  selectedType: string;
  setSelectedType: (type: string) => void;
  selectedStatus: string;
  setSelectedStatus: (status: string) => void;
  minCapacity: string;
  setMinCapacity: (capacity: string) => void;
  maxCapacity: string;
  setMaxCapacity: (capacity: string) => void;
  handleFilter: () => void;
  countryOptions: Record<string, string> | null;
  facilityTypes: string[] | null;
  statuses: string[];
}

const FacilitiesSearchForm: React.FC<FacilitiesSearchFormProps> = ({
  selectedCountry,
  setSelectedCountry,
  selectedType,
  setSelectedType,
  selectedStatus,
  setSelectedStatus,
  minCapacity,
  setMinCapacity,
  maxCapacity,
  setMaxCapacity,
  handleFilter,
  countryOptions,
  facilityTypes,
  statuses,
}) => {
  return (
    <div className="mb-6 border border-gray-300 dark:border-gray-700 rounded-lg p-6">
      <h2 className="text-xl font-semibold mb-4 text-gray-900 dark:text-gray-100">
        Search Power Facilities
      </h2>

      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 mb-4">
        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Country <span className="text-red-500">*</span>
          </label>
          <select
            value={selectedCountry}
            onChange={(e) => setSelectedCountry(e.target.value)}
            className="w-full rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 text-sm focus:border-[rgb(227,66,144)] focus:ring-[rgb(227,66,144)]"
            required
          >
            <option value="" className="text-gray-900 dark:text-gray-100">
              Select a country
            </option>
            {countryOptions &&
              Object.entries(countryOptions).map(([code, name]) => (
                <option key={code} value={name} className="text-gray-900 dark:text-gray-100">
                  {name}
                </option>
              ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Facility Type
          </label>
          <select
            value={selectedType}
            onChange={(e) => setSelectedType(e.target.value)}
            className="w-full rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 text-sm focus:border-[rgb(227,66,144)] focus:ring-[rgb(227,66,144)]"
          >
            <option value="" className="text-gray-900 dark:text-gray-100">
              All Types
            </option>
            {facilityTypes &&
              facilityTypes.map((type) => (
                <option key={type} value={type} className="text-gray-900 dark:text-gray-100">
                  {type}
                </option>
              ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Status
          </label>
          <select
            value={selectedStatus}
            onChange={(e) => setSelectedStatus(e.target.value)}
            className="w-full rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 text-sm focus:border-[rgb(227,66,144)] focus:ring-[rgb(227,66,144)]"
          >
            <option value="" className="text-gray-900 dark:text-gray-100">
              All Statuses
            </option>
            {statuses.map((status) => (
              <option key={status} value={status} className="text-gray-900 dark:text-gray-100">
                {status.charAt(0).toUpperCase() + status.slice(1)}
              </option>
            ))}
          </select>
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Min Capacity (MW)
          </label>
          <input
            type="number"
            value={minCapacity}
            onChange={(e) => setMinCapacity(e.target.value)}
            placeholder="e.g., 100"
            min="0"
            className="w-full rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 text-sm focus:border-[rgb(227,66,144)] focus:ring-[rgb(227,66,144)]"
          />
        </div>

        <div>
          <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-1">
            Max Capacity (MW)
          </label>
          <input
            type="number"
            value={maxCapacity}
            onChange={(e) => setMaxCapacity(e.target.value)}
            placeholder="e.g., 1000"
            min="0"
            className="w-full rounded-md border border-gray-300 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-gray-100 px-3 py-2 text-sm focus:border-[rgb(227,66,144)] focus:ring-[rgb(227,66,144)]"
          />
        </div>
      </div>

      <div className="flex justify-end items-center space-x-3">
        <button
          onClick={handleFilter}
          disabled={!selectedCountry}
          className={`px-4 py-2 rounded-md text-sm font-medium ${
            !selectedCountry
              ? 'bg-gray-300 text-gray-500 cursor-not-allowed'
              : 'bg-black dark:bg-gray-700 hover:bg-gray-800 dark:hover:bg-gray-600 text-white'
          }`}
        >
          Search Facilities
        </button>
      </div>
    </div>
  );
};

export default FacilitiesSearchForm;
